import Parse from "parse";

import type { Document } from "./Document";

export interface DocumentPageAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  annotations: any[];
  document: Document;
  image: Parse.File;
  label: string;
  page: number;
}

export class DocumentPage extends Parse.Object<DocumentPageAttributes> {
  static className: string = "OD3_Knowledge_DocumentPage";

  constructor(data?: Partial<DocumentPageAttributes>) {
    super("OD3_Knowledge_DocumentPage", data as DocumentPageAttributes);
  }

  get annotations(): any[] {
    return super.get("annotations");
  }
  set annotations(value: any[]) {
    super.set("annotations", value);
  }
  get document(): Document {
    return super.get("document");
  }
  set document(value: Document) {
    super.set("document", value);
  }
  get image(): Parse.File {
    return super.get("image");
  }
  set image(value: Parse.File) {
    super.set("image", value);
  }
  get label(): string {
    return super.get("label");
  }
  set label(value: string) {
    super.set("label", value);
  }
  get page(): number {
    return super.get("page");
  }
  set page(value: number) {
    super.set("page", value);
  }
}

Parse.Object.registerSubclass("OD3_Knowledge_DocumentPage", DocumentPage);
